import { render, staticRenderFns } from "./TournamentProducts.vue?vue&type=template&id=5448e7fc"
import script from "./TournamentProducts.vue?vue&type=script&lang=js"
export * from "./TournamentProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports